export const FREE_BLOCK_BOOKING_PROCESS_NAME = 'free-block-booking';
export const PROCESS_NAME = FREE_BLOCK_BOOKING_PROCESS_NAME;
export const FREE_BLOCK_BOOKING_PROCESS_ALIAS = `${FREE_BLOCK_BOOKING_PROCESS_NAME}/release-1`;

export const transitions = {
  INQUIRE: 'transition/inquire',
  REQUEST_PAYMENT: 'transition/request-payment',
  REQUEST_PAYMENT_AFTER_INQUIRY: 'transition/request-payment-after-inquiry',
  ACCEPT: 'transition/accept',
  OPERATOR_ACCEPT: 'transition/operator-accept',
  DECLINE: 'transition/decline',
  OPERATOR_DECLINE: 'transition/operator-decline',
  EXPIRE: 'transition/expire',
  COMPLETE: 'transition/complete',
  OPERATOR_COMPLETE: 'transition/operator-complete',
  CANCEL: 'transition/cancel',
  PROVIDER_CANCEL: 'transition/provider-cancel',
  REVIEW_BY_CUSTOMER: 'transition/review-by-customer',
  EXPIRE_REVIEW_PERIOD: 'transition/expire-review-period',
};

export const states = {
  INITIAL: 'initial',
  INQUIRY: 'inquiry',
  PREAUTHORIZED: 'preauthorized',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  REVIEWED: 'reviewed',
};

export const graph = {
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.INQUIRE]: states.INQUIRY,
        [transitions.REQUEST_PAYMENT]: states.PREAUTHORIZED,
      },
    },
    [states.REVIEWED]: {
      type: 'final',
    },
    [states.INQUIRY]: {
      on: {
        [transitions.REQUEST_PAYMENT_AFTER_INQUIRY]: states.PREAUTHORIZED,
      },
    },
    [states.PREAUTHORIZED]: {
      on: {
        [transitions.ACCEPT]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT]: states.ACCEPTED,
        [transitions.DECLINE]: states.DECLINED,
        [transitions.OPERATOR_DECLINE]: states.DECLINED,
        [transitions.EXPIRE]: states.EXPIRED,
      },
    },
    [states.ACCEPTED]: {
      on: {
        [transitions.COMPLETE]: states.DELIVERED,
        [transitions.OPERATOR_COMPLETE]: states.DELIVERED,
        [transitions.CANCEL]: states.CANCELLED,
        [transitions.PROVIDER_CANCEL]: states.CANCELLED,
      },
    },
    [states.DECLINED]: {},
    [states.EXPIRED]: {},
    [states.DELIVERED]: {
      on: {
        [transitions.REVIEW_BY_CUSTOMER]: states.REVIEWED,
        [transitions.EXPIRE_REVIEW_PERIOD]: states.REVIEWED,
      },
    },
    [states.CANCELLED]: {},
  },
};

export const isRelevantPastTransition = (transition) => {
  return [
    transitions.REQUEST_PAYMENT,
    transitions.REQUEST_PAYMENT_AFTER_INQUIRY,
    transitions.ACCEPT,
    transitions.OPERATOR_ACCEPT,
    transitions.CANCEL,
    transitions.COMPLETE,
    transitions.OPERATOR_COMPLETE,
    transitions.DECLINE,
    transitions.OPERATOR_DECLINE,
    transitions.EXPIRE,
    transitions.REVIEW_BY_CUSTOMER,
  ].includes(transition);
};

export const isCustomerReview = (transition) => {
  return [transitions.REVIEW_BY_CUSTOMER].includes(transition);
};

export const isProviderReview = (_transition) => {
  return false;
};

export const isPrivileged = (transition) => {
  return [transitions.REQUEST_PAYMENT, transitions.REQUEST_PAYMENT_AFTER_INQUIRY].includes(
    transition
  );
};

export const isCompleted = (transition) => {
  const txCompletedTransitions = [
    transitions.COMPLETE,
    transitions.OPERATOR_COMPLETE,
    transitions.EXPIRE_REVIEW_PERIOD,
    transitions.REVIEW_BY_CUSTOMER,
  ];
  return txCompletedTransitions.includes(transition);
};

export const isRefunded = (transition) => {
  const txRefundedTransitions = [transitions.EXPIRE, transitions.CANCEL, transitions.DECLINE];
  return txRefundedTransitions.includes(transition);
};

export const statesNeedingProviderAttention = [states.PREAUTHORIZED];

export const getRequestTransition = (tx) => {
  const isInquiryInPaymentProcess = tx?.attributes?.lastTransition === transitions.INQUIRE;

  if (isInquiryInPaymentProcess) {
    return transitions.REQUEST_PAYMENT_AFTER_INQUIRY;
  }

  return transitions.REQUEST_PAYMENT;
};
